import * as Sentry from '@sentry/react';
import { find } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';

// utils
import { ChatState } from '../../@types/Chat';
import axios from '../../utils/axios';

// @types

// ----------------------------------------------------------------------

const initialState: ChatState = {
  isLoading: false,
  isAssigning: false,
  error: false,
  allMessages: [],
  adminAllMessages: [],
  getAllUser: []
};

const slice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    setErrorDefault(state) {
      state.error = false;
    },

    // START LOADING
    startAssignment(state) {
      state.isAssigning = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getAllMessagesSuccess(state, action) {
      state.isLoading = false;
      state.allMessages = action.payload;
    },
    getNewChatDataSuccess(state, action) {
      state.isLoading = false;
      state.adminAllMessages = action.payload;
    },
    getAllUserListforChat(state, action) {
      state.isLoading = false;
      state.getAllUser = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export function sendMessageByAdmin(FormData: any) {
  return async () => {
    try {
      let response = await axios.post(`/Chat/SendMessage`, FormData, { headers: {
          'Accept-Language': localStorage.getItem('i18nextLng') === 'en' ? 'en-US' : 'ar-SA',
        } });
      return { status: true };
    } catch (error) {
      Sentry.captureException(error);
      dispatch(slice.actions.hasError(true));
      return { status: false };
    }
  };
}

export function getAllUserListforChat(page: number, size: number, IsApproved: boolean) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response =
        await axios.get(`/Clients/GetAllClients?Page=${page}&Size=${size}&OrderBy=CreatedDate&Order=Desc&IsApproved=${IsApproved}
`);
      dispatch(slice.actions.getNewChatDataSuccess(response.data));
    } catch (error) {
      console.error('API Error:', error);
      Sentry.captureException(error);
      dispatch(slice.actions.hasError(true));
    }
  };
}

export function getAllMessages(
  id: any,
  type: number,
  userId: any,
  FromUserId: any,
  Callback?: any
) {
  return async () => {
    dispatch(slice.actions.startLoading());
    if (id == null || id === '') {
      dispatch(slice.actions.getAllMessagesSuccess({ STATUS: false }));
      Callback && Callback({ status: false });
      return;
    }
    try {
      let response = await axios.get(`Chat/GetMessagesChatHistoryForLawyerAndCustomer`, {
        params: {
          ReferenceId: id,
          ReferenceType: type,
          ToUserId: userId,
          FromUserId: FromUserId
        }
      });
      dispatch(slice.actions.getAllMessagesSuccess({ STATUS: true, ...response.data }));
      Callback && Callback(response.data);
    } catch (error) {
      Sentry.captureException(error);
      dispatch(slice.actions.hasError(true));
      dispatch(slice.actions.getAllMessagesSuccess({ STATUS: false, error }));
    }
  };
}

export function getNewChatData(page: number, size: number, callBack?: any) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response =
        await axios.get(`/AppAdmin/AdminChatLawyerCustomerWise?page=${page}&size=${size}
`);
      dispatch(slice.actions.getNewChatDataSuccess(response.data));
      callBack(response);
    } catch (error) {
      console.error('API Error:', error); // Log the API error
      Sentry.captureException(error);
      dispatch(slice.actions.hasError(true));
    }
  };
}
export function setReduceCountNotification(id: number) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`/Account/NotificationsRead?NotificationID=${id}`);
      // dispatch(slice.actions.getNewChatDataSuccess(response.data));
    } catch (error) {
      console.error('API Error:', error); // Log the API error
      Sentry.captureException(error);
      dispatch(slice.actions.hasError(true));
    }
  };
}

//--------------------------------------------------------------------------------------------
